import React from 'react';
import { useSelector } from 'react-redux';

import { Typography } from 'antd';

import './ImagePreviewArea.less';

import { AssetPreview } from 'pages/asset-full-view/components';

import * as productFullViewSelectors from 'pages/product-full-view/controllers/selectors';

import * as productServices from 'services/product';

const { Title } = Typography;

const ImagePreviewArea = (props) => {
  const { title, imageInfo, productInfo, renderDownloadBtn } = props;

  const productHierarchyInfo = useSelector(
    productFullViewSelectors.makeSelectCurrentHierarchy()
  );

  const mapImageInfoToAssetData = (_imageInfo) => {
    return {
      ..._imageInfo,
      fileUrl: _imageInfo?.originalFile,
      metadata: { fileType: _imageInfo?.fileType },
      assetName: _imageInfo?.imageName,
      thumbnail:
        _imageInfo?.thumbFull ||
        _imageInfo?.thumb1000 ||
        _imageInfo?.thumb500 ||
        _imageInfo?.thumb300,
      isOwner: productInfo?.isOwner,
    };
  };

  const reloadDownloadAssetData = async (cachedDownloadUrlRef) => {
    try {
      const response = await productServices.getProductImagery({
        ProductItemHierarchyId: productHierarchyInfo?.productHierarchyId,
        productId: productInfo?.productId,
      });

      const { isSuccess, data } = response;

      if (!isSuccess) return assetData;

      const imageList =
        title === 'Planogram' ? data?.planogramImages : data?.additionalImages;

      if (!imageList?.length) return assetData;

      const imageData = imageList.find((image) => {
        return image?.id === imageInfo?.id;
      });

      //* store new download asset to keep download asset work correctly when change asset selection
      cachedDownloadUrlRef.current = {
        ...cachedDownloadUrlRef.current,
        [assetData?.digitalAssetId]: imageData.originalFile,
      };

      return imageData ? mapImageInfoToAssetData(imageData) : assetData;
    } catch (error) {
      return assetData;
    }
  };

  const assetData = mapImageInfoToAssetData(imageInfo);

  return (
    <div className='image-preview-area'>
      <div className='image-preview-area__image-wrapper'>
        {imageInfo ? (
          <AssetPreview
            assetData={assetData}
            renderDownloadBtn={renderDownloadBtn}
            reloadDownloadAssetData={reloadDownloadAssetData} //* rotate asset - reload asset data to get download url
          />
        ) : (
          <Title level={2} className='image-preview-area__no-preview-message'>
            No Image
          </Title>
        )}
      </div>
    </div>
  );
};

export default ImagePreviewArea;
